<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    props: {
        evento_id: {
            type: Number,
            required: true
        },
        laborante_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            title: "Listado Encuesta",
            items: [
                {
                text: "Digitalización",
                href: "/"
                },
                {
                text: "Listado",
                active: true
                }
            ],
            imagenes:[],
            currentPage: 1,
            perPage: 20,
            pageOptions: [20, 40, 60, 80],
            filtro: '',
            showModalImagen: false,
            modalImagenUrl: '',
            modalRotacion: 0,
            isLoading: false,
        };
    },
    computed:{
        // usar filteredData.length para paginado correcto
        rows() {
            return this.visibleData.length;
        },
        filteredData() {
            // Filtra y luego ordena: primero 'ActualizadoAWS', luego el resto
            return this.imagenes
                .filter((item) => {
                    const filtro = this.filtro.toLowerCase();
                    return (
                        (item.rut && item.rut.toLowerCase().includes(filtro)) ||
                        (item.nombre_completo && item.nombre_completo.toLowerCase().includes(filtro)) ||
                        (item.fecha && item.fecha.toLowerCase().includes(filtro)) ||
                        (item.establecimiento && item.establecimiento.toLowerCase().includes(filtro)) ||
                        (item.curso && item.curso.toLowerCase().includes(filtro)) ||
                        (item.celular && item.celular.toLowerCase().includes(filtro)) ||
                        (item.email && item.email.toLowerCase().includes(filtro)) ||
                        (item.carrera && item.carrera.toLowerCase().includes(filtro)) ||
                        (item.tipo_mime && item.tipo_mime.toLowerCase().includes(filtro))
                    );
                })
                /*.sort((a, b) => {
                    // Ordena primero los que tienen tipo_mime 'ActualizadoAWS'
                    if (a.tipo_mime === 'ActualizadoAWS' && b.tipo_mime !== 'ActualizadoAWS') return -1;
                    if (a.tipo_mime !== 'ActualizadoAWS' && b.tipo_mime === 'ActualizadoAWS') return 1;
                    return 0;
                });*/
         },
        // visibleData contiene solo los registros pares (posición 1-based par: 2,4,6...)
        // cada entrada incluye el item original y su índice dentro de filteredData
        visibleData() {
            return this.filteredData
                .map((it, idx) => ({ item: it, origIndex: idx })) // idx es 0-based
                .filter(entry => ((entry.origIndex + 1) % 2) === 1); // conservar posiciones pares (1-based)
         },
         paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.visibleData.slice(start, end);
         },
         totalPages() {
            return Math.ceil(this.visibleData.length / this.perPage);
         },
     },
    methods: {
        cargarImagenes() {
            console.log(this.evento_id);
            console.log(this.laborante_id);
            this.isLoading = true;
            axios.get('/api/todas_imagenes_digitalizadas', {
                params: {
                    evento_id: this.evento_id,
                    laborante_id: this.laborante_id
                }
            })
            .then(response => {
                this.imagenes = response.data.imagenes || [];
                for (let i = 0; i < this.imagenes.length; i++) {
                    this.imagenes[i].imagen2 = this.imagenes[i + 1] ? this.imagenes[i + 1].url_publica : null;
                }
                if(this.imagenes.length === 0) {
                    this.$bvToast.toast('No hay más imágenes para revisar.', {
                        title: 'Información',
                        variant: 'info',
                        solid: true
                    });
                }
                this.isLoading = false;
            })
            .catch(error => {
                console.error('Error al cargar imágenes:', error);
                this.isLoading = false;
            });
        },
        abrirModalImagen(url) {
            this.modalImagenUrl = url;
            this.showModalImagen = true;
            this.modalRotacion = 0;
        },
        rotarModalIzquierda() {
            this.modalRotacion = (this.modalRotacion - 90) % 360;
        },
        rotarModalDerecha() {
            this.modalRotacion = (this.modalRotacion + 90) % 360;
        },
        eliminarImagen(id) {
            //this.isLoading = true;
            this.$bvModal.msgBoxConfirm('¿Estás seguro que deseas eliminar esta imagen?', {
              title: 'Confirmar eliminación',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: 'Eliminar',
              cancelTitle: 'Cancelar',
              footerClass: 'p-2',
              centered: true
            })
            .then(value => {
              if (value) {
                axios.post('/api/eliminar_imagen_digitalizada', { id })
                  .then(() => {
                    this.$bvToast.toast('Imagen eliminada correctamente', {
                      title: 'Eliminada',
                      variant: 'success',
                      solid: true
                    });
                    this.cargarImagenes();
                    //this.isLoading = false;
                  })
                  .catch(error => {
                    this.$bvToast.toast('Error al eliminar la imagen', {
                      title: 'Error',
                      variant: 'danger',
                      solid: true
                    });
                    console.error(error);
                    //this.isLoading = false;
                  });
              } else {
                //this.isLoading = false;
              }
            });
          },
                // para una fila (entry) devuelve la imagen impar correspondiente (la anterior en filteredData)
                oddImageUrlByOrigIndex(origIndex) {
                    const prevIndex = origIndex - 1;
                    if (prevIndex < 0) return null;
                    const prev = this.filteredData[prevIndex];
                    return prev ? prev.url_publica : null;
                },
    },
    watch: {
        // resetear página al cambiar filtro o perPage
        /*filtro() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        }*/
    },
    created(){
        this.cargarImagenes();
        
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-table font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Datos de Encuesta</h5>
                            <small class="text-white" style="opacity:.8;">Revisa y edita los datos de la encuesta</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 4%;">Nº</th>
                                        <th style="width: 6%;">Img</th>
                                        <th style="width: 6%;">Img 2</th>
                                        <th style="width: 30%;">Estado</th>
                                        <th style="width: 30%;">Nombre</th>
                                        <th style="width: 10%;">Rut</th>
                                        <th style="width: 10%;">Fecha nacimiento</th>
                                        <th style="width: 10%;">Establecimiento</th>
                                        <th style="width: 10%;">Telefono</th>
                                        <th style="width: 10%;">Correo</th>
                                        <th style="width: 10%;">Curso</th>
                                        <th style="width: 10%;">Carrera</th>
                                        <th style="width: 20%;" v-if="user.rol!='Laborante'">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(entry, index) in paginatedData" :key="entry.item.id || entry.origIndex" >
                                        <td>{{ index + 1 }}</td>
                                        <td>
                                            <img 
                                                :src="entry.item.url_publica" 
                                                alt="Imagen" 
                                                style="max-width: 60px; max-height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                                @click="abrirModalImagen(entry.item.url_publica)"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td>
                                            <img
                                                :src="entry.item.imagen2"
                                                alt="Imagen impar"
                                                style="max-width: 60px; max-height: 60px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                                @click="abrirModalImagen(entry.item.imagen2)"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td>{{ entry.item.tipo_mime }}</td>
                                        <td>{{ entry.item.nombre_completo }}</td>
                                        <td>{{ entry.item.rut }}</td>
                                        <td>{{ entry.item.fecha }}</td>
                                        <td>{{ entry.item.establecimiento }}</td>
                                        <td>{{ entry.item.celular }}</td>
                                        <td>{{ entry.item.email }}</td>
                                        <td>{{ entry.item.curso }}</td>
                                        <td>{{ entry.item.carrera }}</td>
                                        <td v-if="user.rol!='Laborante'">
                                            <b-button variant="danger" size="sm" v-if="entry.item.tipo_mime != 'Eliminado'" @click="eliminarImagen(entry.item.id)">
                                                <i class="bx bx-trash"></i> Eliminar
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal v-model="showModalImagen" size="lg" title="Imagen" hide-footer>
          <div class="d-flex justify-content-center mb-3 gap-2">
            <b-button variant="primary" @click="rotarModalIzquierda">
              <i class="bx bx-rotate-left"></i> Izquierda
            </b-button>
            <b-button variant="primary" @click="rotarModalDerecha">
              <i class="bx bx-rotate-right"></i> Derecha
            </b-button>
          </div>
          <img :src="modalImagenUrl" alt="Imagen ampliada" style="width: 100%; max-height: 80vh; object-fit: contain;"
            :style="{ transform: 'rotate(' + modalRotacion + 'deg)' }" />
        </b-modal>
    </Layout>
</template>